import '../DataCollectionGroupPanel.css'

import { ProgressBar, Table } from 'react-bootstrap'

import React from 'react'

export default class UnitCellSection extends React.Component {
  getColorProgressBarByCompleness(completeness) {
    if (parseFloat(completeness) > 90) {
      return 'primary'
    }
    if (parseFloat(completeness) > 50) {
      return 'warning'
    }
    return 'danger'
  }

  getShellStatistics(type, completeness, resolutionLimitLow, resolutionLimitHigh, rMerge) {
    return (
      <tr>
        <td>{type}</td>
        <td>
          <ProgressBar
            bsStyle={this.getColorProgressBarByCompleness(completeness)}
            now={completeness}
            label={completeness + '%'}
          />
        </td>
        <td>
          {resolutionLimitLow} - {resolutionLimitHigh}
        </td>
        <td>{rMerge}</td>
      </tr>
    )
  }

  /*
        <tr style={{borderTop:'1px solid rgb(128, 128, 128)', borderCollapse:'collapse'}}>
            <td  className="parameterValue" style={{textAlign:'center'}} colspan="4">{bestResult.processingProgram}</td>
        </tr>
    */
  render() {
    return (
      <Table responsive condensed style={{ fontSize: '9px', textAlign: 'center' }}>
        <tbody>
          <tr>
            <td>a</td>
            <td>b</td>
            <td>c</td>
          </tr>
          <tr>
            <td className="parameterValue">{this.props.cell_a} Å</td>
            <td className="parameterValue">{this.props.cell_b} Å</td>
            <td className="parameterValue">{this.props.cell_c} Å</td>
          </tr>
          <tr>
            <td>α</td>
            <td>β</td>
            <td>γ</td>
          </tr>
          <tr>
            <td className="parameterValue">{this.props.cell_alpha} °</td>
            <td className="parameterValue">{this.props.cell_beta} °</td>
            <td className="parameterValue">{this.props.cell_gamma} °</td>
          </tr>
        </tbody>
      </Table>
    )
  }
}
